import React, { useMemo, useState } from 'react';
import {
  AppShell,
  Group,
  Text,
  Button,
  Badge,
  Box,
  Anchor,
} from '@mantine/core';
import { IconLogout, IconKey } from '@tabler/icons-react';
import ClientPortalHome from '../pages/client/ClientPortalHome';
import ChangePasswordModal from '../components/ChangePasswordModal';
import { APP_VERSION } from '../lib/appVersion';

export default function ClientPortalLayout({ user, onLogout }) {
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);

  const displayName = user.client_label || user.login;
  const tenantLabel = user.exploitant?.raison_sociale;
  const licenceInfo = useMemo(() => {
    if (!user.licence?.expires_at) return null;
    const expires = new Date(user.licence.expires_at);
    const daysLeft = Math.ceil((expires - Date.now()) / (1000 * 60 * 60 * 24));
    return {
      expiresLabel: expires.toLocaleDateString('fr-FR'),
      daysLeft,
    };
  }, [user.licence?.expires_at]);

  return (
    <AppShell
      header={{ height: 60 }}
      footer={{ height: 50 }}
      padding="md"
      styles={{
        root: { height: '100dvh', overflow: 'hidden' },
        main: {
          minHeight: 0,
          height: '100dvh',
          maxHeight: '100dvh',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <AppShell.Header>
        <Group h="100%" px="md" justify="space-between" wrap="nowrap">
          <Group gap="sm" wrap="nowrap">
            <Text fw={700} size="lg">
              Espace client
            </Text>
            {tenantLabel ? (
              <Badge variant="light" size="lg">
                {tenantLabel}
              </Badge>
            ) : null}
          </Group>
          <Group gap="sm" wrap="nowrap">
            <Text size="sm" c="dimmed" visibleFrom="sm">
              {displayName}
            </Text>
            {licenceInfo ? (
              <>
                <Badge color="teal" variant="light">
                  Licence jusqu&apos;au {licenceInfo.expiresLabel}
                </Badge>
                {licenceInfo.daysLeft <= 30 ? (
                  <Badge color="orange" variant="light">
                    Expire dans {licenceInfo.daysLeft} jour{licenceInfo.daysLeft > 1 ? 's' : ''}
                  </Badge>
                ) : null}
              </>
            ) : null}
            <Button
              variant="subtle"
              size="compact-sm"
              leftSection={<IconKey size={16} />}
              onClick={() => setPasswordModalOpen(true)}
            >
              Mot de passe
            </Button>
            <Button
              variant="light"
              color="red"
              size="compact-sm"
              leftSection={<IconLogout size={16} />}
              onClick={onLogout}
            >
              Déconnexion
            </Button>
          </Group>
        </Group>
      </AppShell.Header>

      <AppShell.Main>
        <Box style={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
          <ClientPortalHome user={user} />
        </Box>
      </AppShell.Main>

      <AppShell.Footer>
        <Group h="100%" px="md" justify="space-between">
          <Text size="xs" c="dimmed">
            JFL Contrôles — espace client
          </Text>
          <Anchor size="xs" c="dimmed">
            v{APP_VERSION}
          </Anchor>
        </Group>
      </AppShell.Footer>

      <ChangePasswordModal
        opened={passwordModalOpen}
        onClose={() => setPasswordModalOpen(false)}
        onSuccess={onLogout}
      />
    </AppShell>
  );
}
